import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios'; // 确保引入 axios

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activePath: [],
    UserToken: '',
    userId: null,  // 存储用户 ID
    currentState:"未通话"
  },
  mutations: {
    // 更新 activePath
    updateActivePath(state, activePath) {
      state.activePath = activePath;
    },
    // 设置 userId
    setUserId(state, userId) {
      state.userId = userId;
    },
    // 设置 currentState
    setCurrentState(state, newState) {
      state.currentState = newState;  // 更新 currentState 为传递过来的新状态
    }
  },
  getters: {
    // 获取 activePath
    getActivePath: (state) => state.activePath,
    // 获取 userId
    userId: (state) => state.userId,
    currentState: (state) => state.currentState
  },
  actions: {
    // 异步获取用户信息并设置 userId
    async fetchUserInfo({ commit }) {
      try {
        const res = await axios.get('/shiro/getUserInfo');
        commit('setUserId', res.data.data.id);  // 调用 mutation 设置 userId
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
  },
  modules: {
    // 如果有模块可以放在这里
  },
});








// import Vue from 'vue';
// import Vuex from 'vuex';
// Vue.use(Vuex);
// export default new Vuex.Store({
//     state: {
//         catch_components: [],
//         activePath: '/index',
//         openNames: [],
//         activeName: "",
//         tranx: "-0",
//         tabList: [
//             { path: '/index', label: '首页', name: '首页' }
//         ]
//     },
//     mutations: {
 
//         //清空vuex数据
//         clearTabs(state) {
//             state.catch_components = []
//             state.activePath = '/homepage'
//             state.openNames = []
//             state.activeName = ""
//             state.tranx = "-0"
//             state.tabList = [
//                 { path: '/homepage', label: '首页', name: 'home' }
//             ]
//         },
       
//         // 添加keepalive缓存
//         addKeepAliveCache(state, val) {
//             if (val === '/homepage') {
//                 return
//             }
//             if (state.catch_components.indexOf(val) === -1) {
//                 state.catch_components.push(val)
//             }
//         },
//         // 删除keepalive缓存
//         removeKeepAliveCache(state, val) {
//             let cache = state.catch_components

//             for (let i = 0; i < cache.length; i++) {
//                 if (cache[i] === val) {
//                     cache.splice(i, 1);
//                 }
//             }
//             state.catch_components = cache
//         },
      
        
//     },
// })
